import React, { Component } from 'react';
import { Switch, Spin, Tooltip, Modal, Button, Icon, Pagination, Avatar, notification, Empty } from 'antd';
import { UndoOutlined, CloseOutlined, UserOutlined  } from '@ant-design/icons';
import { CSVLink } from "react-csv";
import moment from 'moment';
import {formDataSchema} from '../../schema/surgeries_worklist';
import Select2 from '../../components/FormComponent/select2';
import Select2multiple from '../../components/FormComponent/select2/multiple';

import DateRange from '../../components/FormComponent/DateRange';

import Inputlayer from '../../components/FormComponent/Input';
import { filter, formData, dissableFormData } from '../../schema/apppointment';
// import Pagination from "react-js-pagination";
import networkList from '../../constants/networkList';
import postService from '../../services/httpService';
const { addCounsellorComments, getCounsellorCommentsByPatient, homepage }= networkList

const $ = require('jquery');

class Surgeries extends Component {
    showBillDetails = (ip, latest_counselled_by, latest_estimated_amt) => {
        if (ip != null && latest_counselled_by !== null && latest_estimated_amt !== null) {
            this
                .props
                .history
                .push(`/bill-details`, ip);
        } else {
            // notification.error({
            //     message: 'Failure',
            //     description: 'Oops, something went wrong... Please try again.',
            //     duration: 10,
            //     top: 20,
            //     right: 0
            // });
        }

        // alert(ip)
    }
    csvLink = React.createRef()
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            totalItemsCount: 0,
            downloadStatus: 0,
            'thead': [],
            'tbody': [],
            downloadtbody: [],
            commentModal: false,
            comments: null,
            patient_details: {},
            commentsArray: [],
            dateTo: moment().format('YYYY-MM-DD'),
            //dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
            dateFrom: moment().format('YYYY-MM-DD'),
        };
    }


    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }

    componentDidMount() {

        let formSchema = Object.assign({}, formDataSchema);
        formSchema['feilds'].map((feild, key) => {
            if (feild.name === 'doctorid') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Surgeon';
            } else if (feild.name === 'cathfilter') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'OT/Cath';
            }
           else{
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                delete formSchema['feilds'][key]['text'];
            }
            

        })
        this.setState({ activePage: 1, totalItemsCount: 0, 'formData': formSchema['feilds'] }, () => {
            this.loadPage()
        });
    }

    componentWillUnmount() {
        $('footer').css({ 'position': 'relative', top: 'unset' });
        this.setState({ formData: [] });
    }

    loadPage = () => {
        try {
            let This = this;
            let userData = localStorage.getItem('user_data');
            let { activePage, doctor_id, cathfilter, payer_type, bill_value, nurse_station_code, ward_type } = this.state;
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            const { getSurgeriesWorklist } = networkList;
            let tableHead = [];
            tableHead = [
                {
                    "key": 'patient_name',
                    'label': 'Patient Name'
                }, {
                    "key": 'umr',
                    'label': ' UMR'
                },
                {
                    "key": 'ipnumber',
                    'label': 'IP Number'
                }, 
                {
                    "key": 'payer_type',
                    'label': 'Payer Type'
                }, 
                {
                    "key": 'procedure_name',
                    'label': 'Surgery Name'
                },
                {
                    "key": 'surgeon_name',
                    'label': 'Surgeon'
                },
                {
                    "key": 'appointment_date',
                    'label': 'Scheduled Date'
                },
                {
                    "key": 'ot_name',
                    'label': 'Scheduled OT Room'
                },
                {
                    "key": 'booking_type',
                    'label': 'Booking Status'
                },
                
            ]
            let ward_type_value = ''
            if(ward_type){
                if(ward_type.length>1){
                    ward_type_value = 'all'
                }else{
                    ward_type_value = ward_type[0]
                }
            }else{
                ward_type_value = null
            }
            this.setState((state) => ({ downloadStatus: 0, tbody: [], tableTitle: 'Surgeries', thead: tableHead, loadding: true, filename: 'Track-Bills-Report.csv' }), () => {
                postService(getSurgeriesWorklist, 'POST', {
                    "data": {
                        // "unit_id":cathfilter ? cathfilter: userData? userData['unitid'] ? userData['unitid'] : null : null,
                        "unit_id": userData['unitid'],
                        "search_key": this.state.search ? this.state.search : "",
                        "export": 0, //1 for download excel
                        "page_no": activePage,
                        "doctor_id": doctor_id ? doctor_id : [],
                        "unit_filter": cathfilter ? 1 : 0,
                        "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                        "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                       

                    }
                }).then(res => {
                    console.log('tat report:', res);
                    // console.log('data res:', data)
                    if (res.status) {
                        this.setState((state) => ({ totalItemsCount: res.total_items, tbody: res.data, loadding: false }));
                        // enable downloadbtn after 2sec
                        setTimeout(function () {
                            This.setState((state) => ({ downloadStatus: 1 }))
                        }, 2000);
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }
    }

    handleChange(ele) {
        console.log(ele);
        var formFeilds = this.state.formData;
        let { search } = this.state
    }
    submit() {
        var formFeilds = this.state.formData;
        let { search } = this.state
        this.setState(({ doctor_id: formFeilds[0].value, cathfilter: formFeilds[1].value, payer_type: formFeilds[2].value, search: '',activePage: 1, }), () => {
            this.inputRef.value = null;
            this.loadPage()
        })
    }
    searchChange(e) {
        console.log(e.target.value);
        let value = e.target.value
        this.setState((state) => ({ 'search': value }), () => {

        });
    }
    searchClick() {
        this.setState((state) => ({
            activePage: 1,
            tbody: [],
            totalItemsCount: 0,
            doctor_id: [], 
            department_name: [],  
            payer_type: [],  
            bill_value: [],  
            nurse_station_code: [],
            ward_type: []
        }), () => {
            this.loadPage();
            var formFeilds = this.state.formData;
                formFeilds.map((feild, key) => {
                    if (feild.name === 'doctorid') {
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Surgeon';
                    } else if (feild.name === 'cathfilter') {
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'OT/Cath';
                    }else{
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        delete formFeilds[key]['text'];
                    }
                })
                this.setState({ formData: formFeilds })
        })
    }    

    handlePageChange(page) {
        console.log(page);
        this.setState((state) => ({
            activePage: page,
            tbody: []
        }), () => {
            this.loadPage();
        })
    }
   
    clearFilter = () => {
        this.setState(() => ({ doctor_id: '', department_name: '', payer_type: '', bill_value: '', nurse_station_code: '',ward_type: '', search: '', activePage: 1, totalItemsCount: 0 }),
            () => {
                this.inputRef.value = null;
                var formFeilds = this.state.formData;
                formFeilds.map((feild, key) => {
                    if (feild.name === 'doctorid') {
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Surgeon';
                    } else if (feild.name === 'cathfilter') {
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'OT/Cath';
                    }else{
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        delete formFeilds[key]['text'];
                    }
                })
                this.setState({ formData: formFeilds })
                this.loadPage();
            })

    }
  
    dateRange = () => {
        this.setState((state) => ({
            activePage: 1,
            totalItemsCount: 0,
        }), () => {
            this.loadPage(true);
        })        
    }
    navigateTo=(data,index)=>{
        this.setState({loadding:true})
        const { getLatestCounsellingIdForPatient } = networkList;
        let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
        postService(getLatestCounsellingIdForPatient, 'POST', {
            "data": {
                "unit_id": userData&&userData['unitid'] ? userData['unitid']:null,
                 "umr_no": data.umr
            }
        }).then(res => {
            if (res.status && res.data.length>0) {
                this.setState({loadding:false});
                localStorage.setItem("surgeries_list", true);
                this.props.history.push(`/counselling/view-finanical-counselling?pid=${res.data[0].payment_type_id}&cid=${res.data[0].counselling_id}&fid=${res.data[0].form_type}`); 
            } else {
                this.setState({loadding:false});
                    Modal.error({
                        title: 'Failure',
                        content: "No Financial Counselling was done for this Patient.",
                    });
                
            }
        });



    }

    render() {
        let { tableTitle, thead, activePage, tbody, downloadtbody, filename, formData, totalItemsCount, downloadStatus, commentModal, comments, patient_details, commentsArray, loadding } = this.state;
        return (
            <div>               
                <div className="clearfix mx-5">
                <div className="float-left pt-2">
                {tableTitle}
                </div>
                {
                         downloadStatus && tbody != ''
                            ?
                            <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">                                
                                {/* <button className="btn btn-success text-capitalize" onClick={() => { this.downloadFile() }}><img src="/assets/images/icons/download1.png" alt="" className="pr-2" /> <span> Download Report</span></button> */}
                                {/* <CSVLink data={downloadtbody} headers={thead} filename={filename} className="hidden" ref={this.csvLink} />                                 */}
                                <button className="btn btn-light text-capitalize py-1 mr-3" onClick={() => { this.clearFilter() }}><UndoOutlined  className="align-middle pr-2" /><span> Clear</span></button>
                                <button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit()}}><span>Submit</span></button>
                            </div>
                            :
                            <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                {/* <Button className="btn btn-success-disabled text-capitalize" disabled><img src="/assets/images/icons/download1.png" alt="" className="pr-2" /><span> Download Report</span></Button> */}
                                <button className="btn btn-light text-capitalize py-1 mr-3 " onClick={() => { this.clearFilter() }}><UndoOutlined  type="reload" className="align-middle pr-2" /><span> Clear</span></button>                                    
                                <Button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit()}}><span>Submit</span></Button>
                            </div>
                }
                </div>

                <Spin spinning={loadding}>
                    <div className="card ml-5 mr-5 mb-5 card-table">
                        <div className="card-header bg8">
                            <div className="clearfix">
                                <div className="row">
                                    {(formData !== undefined) && <React.Fragment>

                                        {formData
                                            .map((feild, key) => {

                                                if (feild.element === 'input') {
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <div
                                                                className={`${feild.className
                                                                    ? feild.className
                                                                    : 'col '} ${feild.name}`}
                                                                key={key}>
                                                            <div className="input-group" key={key}>
                                                                {/* <input type="text" id="myInput" className="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR or IP" /> */}
                                                                <div
                                                                    className='w-100'
                                                                    key={key}>
                                                                     <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR or IP" onBlur={this.searchChange.bind(this)} ref={(inputRef =>(this.inputRef = inputRef))} />
                                                    <div class="input-group-append" style={{position: 'absolute', right: 0, height: '32px', top: 0}}>
                                                        <button class="btn btn-primary btn-sm" type="button" onClick={this.searchClick.bind(this)}><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                    </div>
                                                                </div>
                                                                {/* <div className="input-group-append" style={{position: 'absolute', right: 0, height: '32px'}}>                                                                    
                                                                    <button className="btn btn-primary btn-sm" onClick={this.search}><img src="/assets/images/icons/search.png" /></button>
                                                                </div> */}
                                                            </div>
                                                        </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                                if (feild.element === 'select2') {
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <div
                                                                className={`${feild.className
                                                                    ? feild.className
                                                                    : 'col '} ${feild.name}`}
                                                                key={key}>
                                                                {/* <p className="data-label text-white w-25 mb-1 pt-1 text-right pr-2">{feild.text2}</p> */}
                                                                <Select2
                                                                    Queuedata={formData}
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={this
                                                                        .handleChange
                                                                        .bind(this)}
                                                                /> {feild
                                                                    .errors
                                                                    .map((error, eKey) => {
                                                                        return (
                                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                        );
                                                                    })}
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                                if (feild.element === 'select2multiple' && feild.visible) {
                                                    return (
                                                        <React.Fragment key={key}>                                                            
                                                            <div
                                                                className={`${feild.className
                                                                    ? feild.className
                                                                    : 'col '} ${feild.name}`}
                                                                key={key}>
                                                                <Select2multiple
                                                                    Queuedata={formData}
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={this
                                                                        .handleChange
                                                                        .bind(this, feild)}
                                                                /> {feild
                                                                    .errors
                                                                    .map((error, eKey) => {
                                                                        return (
                                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                        );
                                                                    })}
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                                if (feild.element === 'daterange') {
                                                    return (
                                                        <div
                                                            className={`${feild.className
                                                                ? feild.className
                                                                : 'col '} ${feild.name}`}
                                                            key={key}>
                                                            {/* <p className="data-label text-white mb-1 pt-1 text-right pr-2">{feild.text}: </p> */}
                                                            
                                                            <DateRange
                                                                Queuedata={formData}
                                                                selectdata={feild}
                                                                {...this.props}
                                                                {...this.state}
                                                                onselectChanges={(e) => { console.log('onselectChanges:', e.value[0]); this.setState({ dateFrom: e.value[0], dateTo: e.value[1] }) }}
                                                            />
                                                           <div class="input-group-append">                                                                           
                                                                <button class="btn btn-primary btn-sm ml-1" onClick={this.dateRange}>Go</button>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            })}

                                    </React.Fragment>}
                                </div>
                            </div>
                        </div>
                        <div className=" table-responsive sticky-header" id="table">
                            <table className="table table-hover table-bordered mb-0  bg-white">
                                <thead>
                                    <tr>
                                        <td className="text-capitalize align-middle">s.no.</td>
                                        {thead.map((head, key) => {
                                            return (<td className="text-capitalize align-middle" key={key}>{head['label']}</td>)
                                        })}
                                    </tr>
                                </thead>
                                {
                                  tbody&& tbody.length>0
                                        ?
                                        <tbody>
                                            {tbody.map((body, key) => {
                                                return (<tr key={key} 
                                                    style={{ 'cursor': 'pointer' }}  onClick={this.navigateTo.bind(this,body)}
                                                // style={(body.ip_no != null && body.latest_counselled_by !== null && body.latest_estimated_amt !== null) ? { 'cursor': 'pointer', 'backgroundColor': '#ffeeba' } : { 'cursor': 'default' }}
                                                >
                                                    <td  
                                                    // onClick={this.showBillDetails.bind(this, body.ip_no, body.latest_counselled_by, body.latest_estimated_amt)}
                                                    >{(key + 1) + (activePage > 1 ? 20 * (activePage > 2 ? (activePage - 1) : 1) : 0)}</td>
                                                    {thead.map((head, Hkey) => {
                                                        // if (head['key'] === 'admission_date') {
                                                        //     return (<td  key={Hkey} >{body['admission_date']?moment(body['admission_date']).format('DD-MM-YYYY HH:mm'):'NA'}</td>)
                                                        // }

                                                        if(head['key'] === 'appointment_date'){
                                                            return (<td key={Hkey} className="text-capitalize"   
                                                            // style={(body.patient_umr != null && body.latest_counselled_by !== null && body.latest_estimated_amt !== null) ? { 'cursor': 'pointer', 'backgroundColor': '#ffeeba' } : {}}
                                                            >{body[head['key']] ? body[head['key']]+' '+body['start_time'] : 'NA'}</td>);
                                                        
                                                        }

                                                        return (<td key={Hkey} className="text-capitalize"  
                                                        >{body[head['key']] ? body[head['key']] : 'NA'}</td>);


                                                       

                                                    })
                                                    }
                                                </tr>)
                                            })}
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                                    <p className="no-data mb-0">No Data</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                }
                            </table>
                        </div>

                    </div>
                    <div className="row justify-content-center align-item-center mx-0">
                        <div className="col pagenation-col mb-3">
                            {/* <Pagination

                                activePage={this.state.activePage}
                                itemsCountPerPage={20}
                                totalItemsCount={totalItemsCount}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange.bind(this)}
                            /> */}
                            <Pagination current={this.state.activePage} total={totalItemsCount} itemRender={this.itemRender.bind(this)} pageSize={20} showSizeChanger={false} onChange={this.handlePageChange.bind(this)} />

                        </div>
                    </div>
                    
                </Spin>
            </div>
        )
    }
}

export default Surgeries;